<template>
  <k-page class="page-starts-organizers">
    <div class="page-starts-organizers__controls">
      <el-tooltip content="Оновити дані" placement="top">
        <el-button @click="update" type="primary" icon="el-icon-refresh-left" circle size="mini" :loading="isStartsOrganizersLoading"></el-button>
      </el-tooltip>

      <el-tooltip content="Додати організатора" placement="top">
        <el-button @click="handleAdd" type="success" icon="el-icon-plus" circle size="mini"></el-button>
      </el-tooltip>
    </div>

    <!-- BEGIN: Pagination -->
    <el-pagination
      v-if="numberOfPages > 1"
      @current-change="setCurrentPage"
      class="the-utils-emails__pagination"
      background
      layout="prev, pager, next"
      :total="startsOrganizersCount"
      small
    >
    </el-pagination>
    <!-- END: Pagination -->

    <k-starts-organizers-list
      :organizers="startsOrganizers"
      @edit="setOrganizer"
      @delete="deleteStartsOrganizer"
    />

    <!-- BEGIN: Pagination -->
    <el-pagination
      v-if="numberOfPages > 1"
      @current-change="setCurrentPage"
      class="the-utils-emails__pagination"
      background
      layout="prev, pager, next"
      :total="startsOrganizersCount"
      small
    >
    </el-pagination>
    <!-- END: Pagination -->

    <k-starts-organizer-edit-form
      :dialogFormVisible="activeStartsOrganizer !== '' || creatigNew"
      :organizer="startsOrganizer"
      @cancel="handleCancel"
      @update="handleUpdateAfterAdd"
    />
  </k-page>
</template>

<script>
/**
 * Page: Страница сипска организаторов забегов
 *
 * @version 1.0.0
 */


import { mapGetters, mapActions } from 'vuex';


// Components
import KPage from '@/components/KPage.vue';
import KStartsOrganizerEditForm from '@/components/KStartsOrganizerEditForm.vue';
import KStartsOrganizersList from '@/components/KStartsOrganizersList.vue';


const NUMBER_OF_ORGANIZERS_PER_PAGE = 10;

export default {
  name: 'page-starts-organizers',

  data() {
    return {
      activeStartsOrganizer: '',
      creatigNew: false,
      currentPage: 0,
    };
  },

  computed: {
    // Общее количество страниц
    numberOfPages() {
      return Math.ceil(this.startsOrganizersCount / NUMBER_OF_ORGANIZERS_PER_PAGE);
    },

    startsOrganizer() {
      const startsOrganizer = this.startsOrganizers.find(item => item._id === this.activeStartsOrganizer);

      return this.creatigNew || !startsOrganizer
        ? {}
        : startsOrganizer;
    },

    ...mapGetters({
      isStartsOrganizersLoading: 'starts/isStartsOrganizersLoading',
      startsOrganizers: 'starts/startsOrganizers',
      startsOrganizersCount: 'starts/startsOrganizersCount',
    }),
  },

  async created() {
    await this.update();
  },

  methods: {
    async update() {
      await this.getStartsOrganizers({
        limit: NUMBER_OF_ORGANIZERS_PER_PAGE,
        offset: this.currentPage,
      });
    },

    setOrganizer(id) {
      this.activeOrganizer = id;
    },

    handleCancel() {
      this.creatigNew = false;
      this.activeOrganizer = '';
    },

    async handleUpdateAfterAdd() {
      await this.update();
      this.creatigNew = false;
      this.activeOrganizer = '';
    },

    async deleteStartsOrganizer(id) {
      await this.deleteStartsOrganizers([id]);
      await this.update();
    },

    // Добавление нового организатора
    handleAdd() {
      this.creatigNew = true;
    },

    ...mapActions({
      deleteStartsOrganizers: 'starts/deleteStartsOrganizers',
      getStartsOrganizers: 'starts/getStartsOrganizers',
    }),
  },

  components: {
    KPage,
    KStartsOrganizerEditForm,
    KStartsOrganizersList,
  },
};
</script>

<style lang="scss">
  .page-starts-organizers {
    display: flex;
    flex-direction: column;

    &__controls {
      margin-bottom: 24px;
    }
  }
</style>
